import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function GlobalBusinessSwitcher(){

  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(()=>{

    const load = async ()=> {
      const ref = collection(db, "businesses");
      const snap = await getDocs(ref);
      const arr = [];
      snap.forEach(s => arr.push({ id: s.id, ...s.data() }));
      setList(arr);
    };

    load();

  }, []);

  return(
    <div className="min-h-screen bg-gray-950 text-white px-6 py-10">

      <h1 className="text-3xl font-bold mb-8">Switch Business</h1>

      <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

        {list.map(b => (
          <div 
            key={b.id} 
            className="py-4 border-b border-gray-800 flex justify-between"
          >
            <div>
              <p className="font-semibold">{b.businessName}</p>
              <p className="text-gray-500">{b.id}</p>
            </div>

            <button
              onClick={()=>navigate(`/admin/impersonate?business=${b.id}`)}
              className="bg-yellow-500 text-black px-4 py-2 rounded"
            >
              Impersonate
            </button>
          </div>
        ))}

      </div>

    </div>
  );
}
